import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { TextField, TextFieldTheme } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useRef, useCallback } from "react";
import { useFocusFieldEvent } from "../../contexts/events-context.js";
import { useForcedState, ForcedState } from "../../contexts/forced-state-context.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { useInvokeCallback } from "../shared/use-invoke-callback.js";
import { Widget } from "../widget/widget.js";
import { classes } from "./url-input-field-wut.st.css";
const UrlInputFieldWUT = ({
  id,
  target,
  value,
  required,
  label,
  hideLabel,
  disabled,
  readOnly,
  placeholder,
  onChange,
  onFocus,
  onBlur,
  description,
  error,
  hasError = false,
  errorMessage,
  FieldLayout,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  widgetHtml,
  widgetEnabled
}) => {
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const invokeBlur = useInvokeCallback(onBlur);
  const inputRef = useRef(null);
  useFocusFieldEvent(() => {
    inputRef.current?.focus({ preventScroll: true });
  }, id);
  const handleBlur = useCallback(() => {
    let updatedValue = "";
    if (value) {
      const urlWithoutProtocol = String(value).replace(/^https?:\/\//, "");
      updatedValue = `https://${urlWithoutProtocol}`;
    }
    onChange(updatedValue);
    invokeBlur();
  }, [value, onChange, invokeBlur]);
  const handleUrlChange = useCallback(
    (event) => {
      const newValue = event.target.value;
      onChange(newValue);
    },
    [onChange]
  );
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          htmlFor: inputId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        TextField,
        {
          id: inputId,
          type: "url",
          error: hasError,
          newErrorMessage: true,
          value: value ? String(value) : "",
          className: classNames(classes.textField, classes.theme, {
            [classes.error]: hasError,
            [classes.hover]: forcedHover
          }),
          onChange: handleUrlChange,
          required,
          disabled,
          readOnly,
          placeholder,
          onBlur: handleBlur,
          onFocus,
          "aria-label": label,
          theme: TextFieldTheme.Box,
          "aria-describedby": ariaDescribedBy,
          "aria-invalid": hasError,
          ref: inputRef
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  UrlInputFieldWUT
};
//# sourceMappingURL=url-input-field-wut.js.map
